import { AUDIENCES_TYPE } from "../constants";

const audiencesReducer = (
  state = {
    data: {
      listAudiences: [],
      page: '',
      page_size: '',
      total: '',
    },
  },
  action
) => {
  switch (action.type) {
    case AUDIENCES_TYPE.GET:
      return {
        ...state,
        data: {
          listAudiences: [...action.payload.listAudiences],
          page: action.payload.page,
          page_size: action.payload.page_size,
          total: action.payload.total,
        },
      };
    default:
      return state;
  }
};
export default audiencesReducer;
